import { AutocompleteOption as BaseAutocompleteOption } from 'redesign';
import { ShiftPlanningFiltersCompany } from '../../../../../hq/services/shift-planning-service.types';

type AutocompleteOption = BaseAutocompleteOption & {
  branchOfficeName?: string;
};

export const getBusinessUnitWithCompanyOptions = (
  companies: ShiftPlanningFiltersCompany[],
  selectedCompany?: AutocompleteOption,
  selectedBranchOffice?: AutocompleteOption[]
) => {
  const options: Record<'companies' | 'branchOffices' | 'departments', AutocompleteOption[]> = {
    companies: [],
    branchOffices: [],
    departments: [],
  };

  if (!companies) {
    return options;
  }

  options.companies = companies.map((company) => {
    return { value: company.companyId, label: company.companyName };
  });

  if (options.companies.length === 0) {
    return options;
  }

  const companyData = companies.find((company) => company.companyId === selectedCompany?.value);

  if (!companyData) {
    return options;
  }

  options.branchOffices = companyData.branchOffices.map((branchOffice) => {
    return {
      label: branchOffice.branchOfficeName,
      value: branchOffice.branchOfficeId,
    };
  });

  if (options.branchOffices.length === 0) {
    return options;
  }

  if (selectedBranchOffice?.length) {
    options.departments = getDepartmentsFromSelectedBranchOffices(
      companyData.branchOffices,
      selectedBranchOffice
    );
  }

  return options;
};

export const getDepartmentsFromSelectedBranchOffices = (
  branchOffices: ShiftPlanningFiltersCompany['branchOffices'],
  selectedBranchOffices: AutocompleteOption[]
): AutocompleteOption[] => {
  const departments: AutocompleteOption[] = [];

  const selectedBranchOfficeIds = selectedBranchOffices.map((bo) => bo.value);

  branchOffices.forEach((branchOffice) => {
    if (selectedBranchOfficeIds.includes(branchOffice.branchOfficeId)) {
      branchOffice.departments.forEach((department) => {
        departments.push({
          label: department.departmentName,
          value: department.departmentId,
          branchOfficeName: branchOffice.branchOfficeName,
        });
      });
    }
  });

  return departments;
};
